import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-50/20">
                  <i className="ri-play-circle-fill text-background-50 text-lg"></i>
                </span>
                <span className="font-heading font-semibold text-lg">免费看片推荐</span>
              </div>
              <p className="text-sm text-background-50/70 leading-relaxed">
                精选正版免费看片平台，涵盖电影、电视剧、纪录片等海量内容，无需付费即可畅享高清画质，帮你快速找到最适合的免费看片渠道。
              </p>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-sm mb-4 text-background-50">
                平台分类
              </h4>
              <div className="flex flex-col gap-2">
                <Link to="/category/zonghe" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">综合平台</Link>
                <Link to="/category/dianying" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">电影专区</Link>
                <Link to="/category/dianshiju" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">电视剧集</Link>
                <Link to="/category/zongyi" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">综艺娱乐</Link>
                <Link to="/category/jilupian" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">纪录片库</Link>
                <Link to="/category/duanshipin" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">短视频追剧</Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-sm mb-4 text-background-50">
                热门推荐
              </h4>
              <div className="flex flex-col gap-2">
                <Link to="/article/bilibili-mianfei-kanpian-tuijian" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">B站免费看片指南</Link>
                <Link to="/article/yangshipin-mianfei-kanpian-tuijian" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">央视频深度评测</Link>
                <Link to="/article/iqiyi-mianfei-kanpian-tuijian" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">爱奇艺免费攻略</Link>
                <Link to="/article/cctv-doc-mianfei-kanpian-tuijian" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">央视纪录片推荐</Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-sm mb-4 text-background-50">
                关于本站
              </h4>
              <div className="flex flex-col gap-2">
                <Link to="/about" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
                <Link to="/about" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">联系我们</Link>
              </div>
              <p className="text-xs text-background-50/50 mt-4">
                本站仅推荐正版平台<br />倡导合法观影
              </p>
            </div>
          </div>

          <div className="border-t border-background-50/15 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/50">
              &copy; {currentYear} 免费看片推荐 mianfeikanpian.com - 正版免费看片平台推荐
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-50/50 hover:text-background-50/70 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-background-50/50 hover:text-background-50/70 transition-colors whitespace-nowrap">使用条款</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}